export default "__VITE_ASSET__ekBPpvpc__"